import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";

@Component({
  selector: "app-issuer",
  // imports: [],
  templateUrl: "./issuer.component.html",
  styleUrl: "./issuer.component.css",
  standalone: false,
})
export class IssuerComponent implements OnChanges {
  @Input() isActive: boolean = false;
  selectedTab: number = 0;
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["isActive"] && changes["isActive"].currentValue === true) {
    }
  }
}
